import React from 'react'

function ActiveAccountLayer() {
  return (
    <div>

    </div>
  )
}

export default ActiveAccountLayer
